import { render } from "./YouTubeEmbed.vue?vue&type=template&id=5f999d58&scoped=true"
import script from "./YouTubeEmbed.vue?vue&type=script&lang=js"
export * from "./YouTubeEmbed.vue?vue&type=script&lang=js"

import "./YouTubeEmbed.vue?vue&type=style&index=0&id=5f999d58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f999d58"]])

export default __exports__